<div
  class="mt-1"
  class="recipients">
  <div class="selection-section recipient-search">
    <div class="body">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="recipients-stats mb-3">
        <div>
          {{ 'COMMUNICATIONS.RECIPIENTS-STATS' | translate : { number: totalRecipients } }}
        </div>
        <button
          class="button is-secondary is-small"
          (click)="addRecipient()"
          style="border-radius: 6px">
          <i class="icon icon-add_plus_zoom-in"></i>
          <span>{{ 'COMMUNICATIONS.ADD-RECIPIENTS' | translate }}</span>
        </button>
      </div>
      <topo-comms-recipient-inline-select
        [(ngModel)]="selectedMembers"
        [channelTypes]="channelTypes"
        [includeUsers]="includeUsers"
        [includeGroups]="includeGroups"
        [includeDistro]="includeDistro"
        [autoClear]="true"
        placeholder="{{ 'COMMUNICATIONS.USER-OR-DIST-ENTRY' | translate }}"
      (selectedMembersChanged)="inlineRecipientsSelected($event)"></topo-comms-recipient-inline-select>
    </div>
  </div>

  @if (selectedRecipients?.length > 0 || datasetsSelected?.length > 0) {
    <div
      class="selection-section"
      >
      <div>
        @if (showAddedRecipients) {
          <div
            class="selected-recipients"
            fxLayout="row"
            fxLayoutAlign="start-between center">
            <div>{{ 'COMMUNICATIONS.ADDED-RECIPIENTS' | translate }}</div>
            <div class="total-counter">
              {{ addedRecipients }}
            </div>
          </div>
        }
        @if (distRecipients?.length) {
          <div
            (click)="onManageDist()"
            class="recipient-section"
            fxLayout="row"
            fxLayoutAlign="space-between center">
            <div
              fxLayout="row"
              fxLayoutAlign="start center">
              <img src="assets/images/purple_distro-group.svg" />
              {{ 'COMMUNICATIONS.RECIPIENT-TYPE-DIST-LIST' | translate }}
              <span class="counter">({{ distRecipients?.length }})</span>
              <span class="counter">({{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: totalDistListContacts } }})</span>
            </div>
            <div
              class="recipient-actions"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="12px">
              <i
                class="icon icon-small_edit"
                (click)="onManageDist()"
              title="{{ 'COMMUNICATIONS.BUTTONS.EDIT' | translate }}"></i>
              <i
                class="icon icon-small_delete-trash"
                (click)="onDeleteDist($event)"
              title="{{ 'COMMUNICATIONS.BUTTONS.DELETE' | translate }}"></i>
            </div>
          </div>
        }
        @if (userRecipients?.length) {
          <div
            (click)="onManageUsers()"
            class="recipient-section"
            fxLayout="row"
            fxLayoutAlign="space-between center">
            <div
              fxLayout="row"
              fxLayoutAlign="start center">
              <img src="assets/images/purple_account-profile.svg" />
              {{ 'COMMUNICATIONS.RECIPIENT-TYPE-USERS' | translate }}
              <span class="counter">({{ userRecipients?.length }})</span>
              <span class="counter">({{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: userRecipients?.length } }})</span>
            </div>
            <div
              class="recipient-actions"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="12px">
              <i
                class="icon icon-small_edit"
                (click)="onManageUsers()"
              title="{{ 'COMMUNICATIONS.BUTTONS.EDIT' | translate }}"></i>
              <i
                class="icon icon-small_delete-trash"
                (click)="onDeleteUsers($event)"
              title="{{ 'COMMUNICATIONS.BUTTONS.DELETE' | translate }}"></i>
            </div>
          </div>
        }
        @if (groupRecipients?.length) {
          <div
            (click)="onManageGroups()"
            class="recipient-section"
            fxLayout="row"
            fxLayoutAlign="space-between center">
            <div
              fxLayout="row"
              fxLayoutAlign="start center">
              <img src="assets/images/people-group.svg" />
              {{ 'COMMUNICATIONS.RECIPIENT-TYPE-GROUPS' | translate }}
              <span class="counter">({{ groupRecipients?.length }})</span>
            </div>
            <div
              class="recipient-actions"
              fxLayout="row"
              fxLayoutAlign="start center"
              fxLayoutGap="12px">
              <i
                class="icon icon-small_edit"
                (click)="onManageGroups()"
              title="{{ 'COMMUNICATIONS.BUTTONS.EDIT' | translate }}"></i>
              <i
                class="icon icon-small_delete-trash"
                (click)="onDeleteGroups($event)"
              title="{{ 'COMMUNICATIONS.BUTTONS.DELETE' | translate }}"></i>
            </div>
          </div>
        }
        @for (datasetInfo of datasetsSelected; track datasetInfo.uId) {
          <div>
            <div class="recipient-section">
              @if (datasetInfo?.documentCount) {
                <div
                  [title]="datasetInfo?.filterDisplay || ''"
                  (click)="onManageDataset(datasetInfo.uId)"
                  fxLayout="row"
                  fxLayoutAlign="space-between center">
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    <img
                      class="dataset"
                      [src]="datasetInfo.datasetIcon" />
                    {{ datasetInfo.datasetName }}
                    <span class="counter">({{ datasetInfo?.documentCount }})</span>
                    <span class="counter">({{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: datasetInfo.contactCountDisplay } }})</span>
                  </div>
                  <div
                    class="recipient-actions"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="12px">
                    @if (!!datasetInfo.relatedAssetName) {
                      <div
                        fxLayout="row"
                        fxLayoutAlign="start center"
                      id="include-related"></div>
                    }
                    <i
                      class="icon icon-small_edit"
                      (click)="onManageDataset(datasetInfo.uId)"
                    title="{{ 'COMMUNICATIONS.BUTTONS.EDIT' | translate }}"></i>
                    <i
                      class="icon icon-small_delete-trash"
                      (click)="onDeleteDataset(datasetInfo.datasetUId, $event)"
                    title="{{ 'COMMUNICATIONS.BUTTONS.DELETE' | translate }}"></i>
                  </div>
                </div>
              }
              @if (!!datasetInfo?.documentCount && !!datasetInfo?.relatedAssetName) {
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  id="include-related"
                  style="margin-top: 8px">
                  <div style="margin-left: 32px">
                    <topo-checkbox
                      [checked]="datasetInfo.sendToRelatedAssets"
                    (checkChanged)="onSendToRelatedAssetsChanged(datasetInfo, $event)"></topo-checkbox>
                  </div>
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    @if (!datasetInfo?.relatedAssetIsCustomIcon) {
                      <div
                        class="asset-icon"
                        [style]="'background-color:' + (datasetInfo.relatedAssetColor || '#FFFFFF') + ';color: #FFFFFF'"
                        fxLayout="row"
                        fxLayoutAlign="space-around center">
                        <div
                          class="material-icons"
                          style="font-size: 16px">
                          {{ datasetInfo.relatedAssetIcon }}
                        </div>
                      </div>
                    }
                    @if (!!datasetInfo?.relatedAssetIsCustomIcon) {
                      <div
                        class="asset-icon"
                        [style]="'background-color:' + (!lay ? '#FFFFFF' : datasetInfo.relatedAssetColor) + ';color: #FFFFFF'">
                        <img
                          [src]="datasetInfo.relatedAssetIcon | safeUrl"
                          style="width: 16px; height: 16px; margin: 4px 0px 0px 4px" />
                      </div>
                    }
                    <div
                      style="font-weight: 600"
                      class="ml-2">
                      {{ datasetInfo.relatedAssetName }}
                    </div>
                    <div class="counter ml-1">
                      ({{ datasetInfo.relatedCountDisplay }})
                      <span>({{ 'COMMUNICATIONS.TOTAL-CONTACTS' | translate : { number: datasetInfo.relatedContactCount ?? '...' } }})</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (showTemplateRecipients) {
    <topo-comms-recipients-from-template
    [template]="template"></topo-comms-recipients-from-template>
  }
</div>

<topo-comms-recipient-list-select
  #listSelect
  [getSelectedUIds]="getSelectedUIds"
  [isDuplicateFilter]="isDuplicateFilter"
  [intitalSelectedTypeUId]="selectedRecipientTypeUId"
  [recipientFilters]="[recipientFilter]"
  [isActive]="recipientsSelectionActive"
  [includeUsers]="includeUsers"
  [includeGroups]="includeGroups"
  [includeDistro]="includeDistro"
  [includeDatasets]="includeDatasets"
  (recipientsSelected)="recipientsSelected($event)"
(recipientsClosed)="recipientsClosed()"></topo-comms-recipient-list-select>

<topo-confirm
  [isActive]="showConfirmation"
  (respond)="onConfirm($event)"
  [title]="confirmationTitle"
  [message]="confirmationMessage"
  yesText="{{ 'COMMUNICATIONS.CONFIRM-YES' | translate }}"
  noText="{{ 'COMMUNICATIONS.CONFIRM-NO' | translate }}"
icon="icon-close-X"></topo-confirm>
